export const BUILD_ID = 'a84f27f1-e52a-4490-8078-e4ab4fc71b19';
export const ENV = 'production';
